<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'ProjectPurposes',
    components: {
      NsiTable,
    },
    data() {
      return {
        canEdit: true,
        pageTitle: 'Цели проекта',
        apiRoute: 'MpkProjectPurpose',
        cardName: 'ProjectPurposeCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
